







































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class ConversionView extends Vue {
  public items: Common.Conversion[] = new Array(0);
  public params: Common.ConversionQuery = new Common.ConversionQuery();
  public importQuery = new Common.ConversionImportQuery('荷姿');
  public exportQuery = new Common.ConversionExportQuery('荷姿', this.params);
  @Prop() public auditNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'commodity', text: '商品'},
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];


  public hasLicenseTrade: boolean = false;
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],3, 'grid');

  public created() {

    // ライセンスによって表示項目を制御する
    this.hasLicenseTrade = this.$api.hasLicense(Common.licenseFlags.import) || this.$api.hasLicense(Common.licenseFlags.export);
    this.exportQuery.hasLicenseCurrency = this.hasLicenseTrade;
    this.importQuery.hasLicenseCurrency = this.hasLicenseTrade;
//'状態','ワークフロー', '商品コード', '商品', 'コード', '名称', '入数(換算係数)', 'Net(kg)', 'Gross(kg)', 'Volume(m3)',  '初回保存日', '初回保存者 ', '最終更新日', '最終更新者'
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      // new Common.GridItemConfiguration('商品コード', 150),
      new Common.GridItemConfiguration('商品', 200),      
      new Common.GridItemConfiguration('コード', 150),
      new Common.GridItemConfiguration('名称', 200),
       new Common.GridItemConfiguration('入数(換算係数)', 150),
      new Common.GridItemConfiguration('Net(kg)', 150,this.hasLicenseTrade),
      new Common.GridItemConfiguration('Gross(kg)', 150,this.hasLicenseTrade),
      new Common.GridItemConfiguration('Volume(m3)', 150,this.hasLicenseTrade),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者 ', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150)
    );

    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;    



    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }
    if (this.commodity){
      this.params.commodity = this.commodity;
    }
    if(!this.auditNo && !this.commodity) {
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    this.$api.formatter.ensureListLoaded('workflow_masterBase');            
  }

  public async onCreate(obj: Common.Conversion) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    if (this.popup && this.commodity) obj.commodity = this.commodity;    
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Commodity):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public isEditable(state: Common.MasterBaseStatus):boolean{
    return state == Common.MasterBaseStatus.NotPosted;
  }
}
